import { createContext, useContext } from "react";
import type { PortBridgeClient } from "./bridge-client";

/**
 * React context carrying the plugin's active {@link PortBridgeClient}.
 * Provided by the host mount (WorkerMockHost in dev, real bridge in production)
 * and consumed by `useBridgeTheme`, `useBridgeLocale`, and the `plugin-ui` hooks.
 */
export const BridgeClientContext = createContext<PortBridgeClient | null>(null);

/**
 * Returns the bridge client from context, throwing a clear error when missing.
 * Used by the `useBridge*` hooks to fail loudly on misconfiguration.
 */
export function useBridgeClient(): PortBridgeClient {
  const client = useContext(BridgeClientContext);
  if (client === null) {
    throw new Error(
      "No PortBridgeClient available. Wrap your plugin in <BridgeClientProvider> "
      + "or ensure the host mount wires a BridgeClientContext.Provider.",
    );
  }
  return client;
}
